export default __webpack_public_path__ + "static/media/management.308d431e.svg";